import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBlogByIdFn, getBlogSubCategoryFn, patchBlogFn, postBlogFn } from 'Services/Blog';
import { getTestimonialByIdFn, patchTestimonialFn, postTestimonialFn } from 'Services/Testimonial';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';
import SelectInput from 'Shared/SelectInput';

const AddUpdateTestimonial = () => {
    const [subOptions, setSubOptions] = useState([]);
    const navigate = useNavigate();
    const { id, status } = useParams();


    const { data: response } = useQuery({
        queryKey: ['testimonial', id, status],
        queryFn: () => getTestimonialByIdFn(id),
        enabled: !!id && status === "update"
    });
    const data = response?.data?.data;



    const { mutate: post } = useMutation(postTestimonialFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/testimonial/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const { mutate: patch } = useMutation(patchTestimonialFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/testimonial/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const initialValues = {

        image: "",
        name: data?.name || "",
        message: data?.message || "",
        client_profile: data?.client_profile || ""
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.name) return toast.error("Name is required.");
            // if (!values.sub_category) return toast.error("Sub Category is required.");
            if (!values.message) return toast.error("Message is required.");

            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('message', values.message);
            formData.append('client_profile', values.client_profile);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.");
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("testimonial_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div className="p-4">
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-6 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl text-black font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Testimonial
                </p>
                <CustomInput formik={formik} label="Name" name="name" />

                <CustomInput formik={formik} label="Client Profile" name="client_profile" />

                <ImageInput formik={formik} label="Image" name="image" />

                <CustomInput formik={formik} multiline label={"Message"} name={"message"} rows={3} />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    );
};

export default AddUpdateTestimonial;
